module.exports = __webpack_public_path__ + "static/media/down-outline-arrow-grey.57e749b4.svg";